import React from 'react';
import { MenuItem } from '@mui/material';
import { MoSelect } from '@motivo/guanyin/src/components';
import { type Entity } from './EntityDetails';

export function getEntityKey(entity: Entity) {
  return `${entity.__typename}-${entity.id}`;
}

interface EntitySelectorProps {
  entities: Entity[];
  value: string;
  onChange: (entityKey: string) => void;
}

export default function EntitySelector({ entities, value, onChange }: EntitySelectorProps) {
  return (
    <MoSelect
      name="entity-select"
      label="Motivo user"
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
    >
      {entities.map((entity) => {
        const entityKey = getEntityKey(entity);
        return (
          <MenuItem key={entityKey} value={entityKey}>
            {entity.fullName} ({entity.email})
          </MenuItem>
        );
      })}
    </MoSelect>
  );
}
